const signEdit = [{
  path: 'signEdit/index',
  component: resolve => require(['../../../../components/pages/user/signEdit'], resolve)
}]

export default signEdit
